import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

interface UseEquipmentModelEquipmentsProps<T> {
  modelIntegrationCodeId?: string
  filters?: {
    search?: string
    enabled?: boolean
  }
  mapper?: (data: any) => T
}

export const useEquipmentModelEquipments = <T,>({
  modelIntegrationCodeId,
  filters: { search = '', enabled = true } = {},
  mapper = Mapper.default<T>(),
}: UseEquipmentModelEquipmentsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['equipmentModelEquipments', modelIntegrationCodeId, search],
    enabled: enabled && !!modelIntegrationCodeId,
    queryFn: () => {
      return privateAxios.get(`/equipment_models/${modelIntegrationCodeId}/equipments`, {
        params: { search: search || undefined },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
